<template>
  <v-container fluid>
    <v-btn text style="padding-left: 5px  !important" @click="$router.push({ name: 'appointment' })">
      <v-icon left>mdi-arrow-left</v-icon>
      Назад к списку
    </v-btn>

    <template v-if="doctor">
      <v-row>
        <v-col>
          <h1>{{ doctor.fullName }}</h1>
        </v-col>
      </v-row>

      <div class="mt-5">
        <Schedule :doctor="doctor" />
      </div>
    </template>
  </v-container>
</template>

<script>
import AppointmentSearch from "./components/AppointmentSearch";
import AppointmentCard from "@/views/pages/appointment/components/AppointmentCard.vue";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";
import { Doctor } from "@/modules/doctors/Doctor.js";
import Schedule from "@/modules/schedule/Schedule.vue";
import { ReferencesRepository } from "@/modules/references/references.repository.js";

export default {
  name: "AppointmentDetail",

  components: {
    Schedule,
    AppointmentCard,
    AppointmentSearch,
  },

  data() {
    return {
      /** @type {Doctor|null} */
      doctor: null,
    };
  },

  async created() {
    this.doctor = await DoctorsRepository.getById(this.$route.params.id);
    await ReferencesRepository.serviceProvidingWays({ forAppointment: true });
  },

  methods: {},
};
</script>

<style scoped></style>
